import { useRecoilState } from 'recoil'
import classNames from 'classnames'

import { currentAlertState } from 'services/alert/atom'
import AlertItem from './components/AlertItem'

import './alertContainer.style.css'

const AlertContainer = () => {
  const [alerts] = useRecoilState(currentAlertState)

  const classname = classNames('alert-container', {})

  return (
    <div className={classname}>
      {alerts.map((alert, ind) => (
        <AlertItem alert={alert} key={ind} index={ind} />
      ))}
    </div>
  )
}

export default AlertContainer
